


































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import DiagramsToCompare from '@c/diagrams/DiagramsToCompare.vue';
import {IndexInterval} from '@u/indexInterval';
import {DiagramData, DiagramSettings, Freqband} from '@/interfaces/diagrams';
import Loading from '@c/controls/Loading.vue';
import userSettingsStoreModule from '@/store/modules/userSettingsModule';
import {SpectrumEventType, SpectrumYAxisType} from '@/enums/diagrams';
import {getYAxisName} from './utils';
import {getApiStoreSpectrum} from './utils';
import {PMSettings} from '@/views/administration/users/interfaces';

@Component({
  components: {
    DiagramsToCompare,
    Loading,
  },
})
export default class SpectrumDiagramBox extends Vue {
  @Prop({required: false})
  span_nodes!: any;

  // Данные графика
  data: any = {
    mainDiagram: {data: [], yAxis: {name: '', units: ''}, name: '', id: '', visible: true},
    comparedDiagrams: [],
    spectrumType: SpectrumEventType.Low,
  };

  chartData: DiagramData = {
    data: [],
    yAxis: {name: '', units: ''},
    name: '',
    id: '',
    visible: true,
  };

  leftX = 0;
  rightX = 0;
  dataLength = 0;

  comparedChartsData: DiagramData[] = [];

  spectrumYAxisType: SpectrumYAxisType = SpectrumYAxisType.VDecibels;

  onItemLegendClicked(e: any) {
    this.$emit('itemLegendClick', e);
  }

  addNewSpectrums(timestamps: any) {
    this.$emit('addNewSpectrums', timestamps, this.spectrumId);
  }

  async changeYAxisType(params: {value: SpectrumYAxisType; recalc: boolean}) {
    this.spectrumYAxisType = params.value;

    if (!params.recalc) return;

    try {
      this.loading = true;
      this.setDiagrams();
    } catch {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  // Действия при выборе новой настройки центральной частоты и ширины полосы для трехосного спектра огибающей dtcp-акселерометра
  async changeFreqband(freqband: Freqband) {
    this.freqband = freqband;
    this.setDiagrams();
  }

  // Текущая дата спектра
  currentTimestamp: any = null;

  // Переменная для отслеживания изменения сравниваемых графиков
  changedComparedCharts = 0;

  // Показатели загрузки данных и ошибки загрузки данных
  loading = false;
  error = false;

  spectrumId = null;

  addedTimestamps: any = [];

  @Prop({required: true})
  diagrams!: any[];

  @Prop({required: true})
  diagramsKey!: number;

  @Prop({required: true})
  selectedAccelerometerId!: number;

  @Watch('diagramsKey')
  updateDiagrams() {
    this.setDiagrams();
  }

  @Watch('diagrams')
  async onChangeDiagrams() {
    this.setDiagrams();
  }

  isYLogAxis = false;

  hideZeroFrequency: boolean | null = null;

  // Сохранённая частота
  freqband: Freqband | null | undefined = null;

  // Значение оси Y заданное в вибродиагностике для спектров с виброскоростью и виброускорением
  @Prop({required: false})
  vibrationSpectrumYAxisType!: SpectrumYAxisType;

  // Флаг сохранения настроек, если false, храним настройки во временной области localstorage
  @Prop({required: false, default: true})
  saveSettings!: boolean;

  shouldSaveSettings = this.saveSettings;

  @Prop({required: false})
  freqbands!: Freqband[];

  @Watch('vibrationSpectrumYAxisType', {immediate: true})
  onChangeVibrationSpectrumYAxisType(newVal: SpectrumYAxisType) {
    if (newVal) this.spectrumYAxisType = newVal;
  }

  // Минимальное значение масштаба по оси X
  xMinScaleValue = 1;

  // Данные примененного зума
  zoomData: {offset: number; length: number; startX?: number; endX?: number} | null = null;

  // Показатель того, что применен зум
  isInZoom = false;

  async created() {
    if (this.diagrams[0].isYLogAxis !== undefined) {
      this.isYLogAxis = this.diagrams[0].isYLogAxis;
    }
    if (
      this.diagrams[0].hideZeroFrequency !== undefined &&
      this.diagrams[0].hideZeroFrequency !== null
    ) {
      this.hideZeroFrequency = this.diagrams[0].hideZeroFrequency;
    }
    if (this.diagrams[0].freqbandId) {
      this.freqband = this.freqbands.find(freqband => freqband.id === this.diagrams[0].freqbandId);
    }

    await this.setDiagrams();
  }

  async setDiagrams() {
    try {
      this.loading = true;
      this.error = false;

      const data: DiagramData[] = [];

      this.addedTimestamps = [];

      for (const diagram of this.diagrams) {
        const K = (diagram.customDataRightX - diagram.customDataLeftX) / diagram.customDataLength;
        const {spectrum, leftX, rightX, dataLength, timestamp} = await getApiStoreSpectrum(
          diagram.moduleType,
        ).getSpectrum({
          id: diagram.moduleId,
          spectrumType: diagram.measurement.spectrumType,
          date: diagram.time,
          spectrumValueType: this.spectrumYAxisType,
          fieldAlias: diagram.measurement.alias,
          central_frequency: this.freqband?.central_frequency,
          bandwidth: this.freqband?.bandwidth,
          offset: this.zoomData?.startX ? Math.floor(this.zoomData?.startX / K) : undefined,
          length:
            this.zoomData?.startX && this.zoomData?.endX
              ? Math.floor((this.zoomData?.endX - this.zoomData?.startX) / K)
              : undefined,
        });

        diagram.customDataLeftX = leftX;
        diagram.customDataRightX = rightX;
        diagram.customDataLength = dataLength;

        const updateDate = new Date(diagram.time || timestamp);
        const date = updateDate ? updateDate.toLocaleString() : '';
        data.push({
          data: spectrum,
          yAxis: {
            name: getYAxisName(diagram),
            units: diagram.measurement.unit != '-' ? diagram.measurement.unit : '',
          },
          name: date,
          id: diagram.id,
          visible: diagram.visible,
        });
        this.addedTimestamps.push(diagram.time);
        this.spectrumId = diagram.id;
        this.leftX = leftX;
        this.rightX = rightX;
        this.dataLength = dataLength;
      }

      this.chartData = data[0];
      this.comparedChartsData = data.slice(1);
      this.setData();
      this.changedComparedCharts++;
    } catch (e) {
      console.log(e);
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  // Действие при сбросе зума
  async returnInitialStateChart() {
    if (this.isInZoom) {
      this.isInZoom = false;
      this.zoomData = null;
      this.setDiagrams();
    }
  }

  // Действия при зуме графика
  async onChartZoom(indexInterval: IndexInterval) {
    this.isInZoom = true;

    const indexDiff = indexInterval.endIndex - indexInterval.startIndex + 1;
    try {
      this.loading = true;
      this.error = false;
      this.zoomData = {
        offset: indexInterval.startIndex + 1,
        length: indexDiff,
        startX: indexInterval.startX,
        endX: indexInterval.endX,
      };

      this.setDiagrams();
    } catch {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  setData() {
    this.data = {
      mainDiagram: this.chartData,
      comparedDiagrams: this.comparedChartsData,
      spectrumType: this.diagrams[0].measurement.spectrumType,
    };
  }

  async onUpdateUserSettings(settings: DiagramSettings) {
    const model: PMSettings = {
      pModuleId: this.diagrams[0].moduleId,
      measurementId: this.diagrams[0].measurement.id,
      measurementType: this.diagrams[0].measurement.type,
      color: 'black',
      freqbandId: settings.freqband?.id,
      isYLogAxis: settings.isYLogAxis,
      hideZeroFrequency: settings.hideZeroFrequency,
    };
    if (this.shouldSaveSettings) {
      // TODO: заменить на сохранение в БД
      await userSettingsStoreModule.saveDiagramSettings(model);
    } else {
      // если не нужно сохранять, то держим настроки в localStore пока используем
      await userSettingsStoreModule.saveTempDiagramSettings(model);
    }
  }
}
